
import { Link } from 'react-router-dom';
import './Contacts.css';

const Contacts = () => (
  <div className="breadcrumbs">
    
      <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → Контакты
      </div>

    <div className="content">
      <div className="content_white_cloud">
        <div className="cwc_top"></div>
        <div className="cwc_mid">
          <div className="content">
            <h2>КОНТАКТЫ</h2>
            <br/><hr></hr><br/>
            <div className="card-container">
    <div className="card">
      <h3 className="card-title">
        СЕРГЕЙ МАВРОДИ
      </h3>
      <table className="card-table">
        <tbody>

          <tr>
            <td>
              Официальный сайт:&nbsp;
              <a
                href="https://sergey-mavrodi.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                sergey-mavrodi.com
              </a>
            </td>
          </tr>
          <tr>
            <td>
              Зеркала:&nbsp;  
              <a
                href="https://sergey-mavrodi.ms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '17px', textDecoration: 'none' }}
              >
                sergey-mavrodi.ms
              </a>&nbsp;/&nbsp;  
              <a
                href="https://mavrodi-mmm-2011.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '17px', textDecoration: 'none' }}
              >
                mavrodi-mmm-2011.com
              </a>   
            </td>
          </tr>
          
          <tr>
            <td>
              Почта:&nbsp;  
              <a
                href="mailto:mmm-2011@sergey-mavrodi.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                mmm-2011@sergey-mavrodi.com
              </a>
            </td>
          </tr>
          <tr>
            <td>
              Администратор:&nbsp;  
              <a
                href="mailto:theatermavrodi@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                theatermavrodi@gmail.com
              </a>
            </td>
          </tr>
          <tr>
            <td>
              Личный кабинет:&nbsp;  
              <a
                href="mailto:system@sergey-mavrodi.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                system@sergey-mavrodi.com
              </a>
            </td>
          </tr>
          <tr>
            <td className="card-note">
              P.S. И имейте в виду. Всё предварительно читает Администратор. <br/>Просто честно предупреждаю. Во избежание. :-))
            </td>
          </tr>
          <tr>
            <td>
            KinoTheater LUZIFER:
    <a href="https://vk.com/theatermavrodi" target="_blank" rel="noopener noreferrer">
      <img src="/images/v1.webp" alt="VK" width="20" height="20" style={{ marginLeft: '20px' }} />
    </a>
    <a href="https://www.facebook.com/profile.php?id=100056900434020" target="_blank" rel="noopener noreferrer">
      <img src="/images/f2.webp" alt="Facebook" width="20" height="20" style={{ marginLeft: '20px' }} />
    </a>
    <a href="https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg" target="_blank" rel="noopener noreferrer">
      <img src="/images/y3.webp" alt="YouTube" width="20" height="20" style={{ marginLeft: '20px' }} />
    </a>
    <a href="https://rutube.ru/channel/39271788/" target="_blank" rel="noopener noreferrer">
      <img src="/images/r4.webp" alt="RuTube" width="20" height="20" style={{ marginLeft: '20px' }} />
    </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
          </div>
        </div>
        <div className="cwc_bot"></div>
      </div>
    </div>
  </div>
);

export default Contacts;
